import {
  GlobalPresenceOption,
  LocationTypeOption,
} from "@/components/filters/UserFilters/GlobalPresenceFilter/constants";

/**
 * UI state for the Global Presence filter. Mirrors the local state of the
 * Projects-side useGlobalPresenceFilter hook; serialized to the GraphQL
 * `globalPresence` shape by mapper.ts.
 *
 * subMatch: "ANY" | "ALL" | "1".."10" (numeric string = "at least N").
 */
export type GlobalPresenceSlice = {
  option: GlobalPresenceOption;
  showHq: boolean;
  showSub: boolean;
  hqType: LocationTypeOption;
  hqValues: string[];
  subType: LocationTypeOption;
  subValues: string[];
  subMatch: string;
};

export const defaultGlobalPresenceSlice: GlobalPresenceSlice = {
  option: GlobalPresenceOption.NONE,
  showHq: false,
  showSub: false,
  hqType: LocationTypeOption.COUNTRY,
  hqValues: [],
  subType: LocationTypeOption.COUNTRY,
  subValues: [],
  subMatch: "ANY",
};
